<template>
  <div class="container-prop-component">
    <div v-if="schema.HintText" class="d-flex justify-end">
      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          mdi-information-outline
        </v-icon>
      </template>
      <span>{{ $t(schema.HintText) }}</span>
    </v-tooltip>
    </div>
    <v-text-field
      :disabled="readonly"
      :label="$t(schema.name || propName)"
      :type="type"
      :rules="textFieldRules"
      v-model="localValue"
      :hint="$t(schema.name || propName)"
      persistent-hint
      dense
      filled
      @change="$emit('change', localValue)"
    >
    </v-text-field>
  </div>
</template>
<script>
export default {
  name: 'dr-property-text-field',
  props: ['schema', 'propName', 'value', 'readonly'],
  inject: ['stateName'],
  data() {
    return {
      type: ''
    }
  },

  created() {
    this.type = this.schema.type == 'string' ? 'text' : 'number'
    if (this.schema.onCreate) {
      this.schema.onCreate(this)
    }
  },
  computed: {
    textFieldRules() {
      if (!this.schema?.validationRules) {
        return []
      }
      return this.schema.validationRules.map((e) => {
        return (val) => val.match(e.regexTemplate) && this.$t(e.errorMessage)
      })
    },

    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
